var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgXWhite(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M14.1209 12L23.5605 2.56137C24.1465 1.97541 24.1465 1.02538 23.5605 0.43947C22.9745 -0.14649 22.0245 -0.14649 21.4386 0.43947L12 9.87905L2.56137 0.43947C1.97541 -0.14649 1.02538 -0.14649 0.43947 0.43947C-0.146443 1.02543 -0.14649 1.97545 0.43947 2.56137L9.87905 12L0.43947 21.4386C-0.14649 22.0246 -0.14649 22.9746 0.43947 23.5605C1.02543 24.1464 1.97545 24.1465 2.56137 23.5605L12 14.1209L21.4386 23.5605C22.0245 24.1465 22.9745 24.1465 23.5605 23.5605C24.1464 22.9745 24.1464 22.0245 23.5605 21.4386L14.1209 12Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgXWhite);
export default __webpack_public_path__ + "static/media/x-white.6a9383cf6eedad66509ae93d488fcf93.svg";
export { ForwardRef as ReactComponent };